<div class="form-group row">
  @if (!screenSizeService.isXs || (props.label && !props.hideLabel)) {
    <label
      class="col-sm-{{ labelColumns }} col-form-label {{ props.mobileSplit || isMobile ? 'mt-2' : '' }}"
      [attr.for]="id"
    >
      @if (!props.hideLabel) {
        <span
          >{{ props.label }}
          @if (props.required && !menuService.isReadOnly) {
            *
          }
        </span>
      }
    </label>
  }
  <div class="col-sm-{{ fieldColumns }}">
    <ng-template #fieldComponent></ng-template>
    @if (showError && !menuService.isReadOnly) {
      <div class="invalid-feedback d-block">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    }
  </div>
</div>
